import { useTheme } from "@mui/material/styles";
import { motion, MotionValue } from "framer-motion";

import Box from "@mui/material/Box";

type Props = {
  idx: number;
  setRef: (el: HTMLDivElement | null) => void;
  badgeBg: MotionValue<string>;
  badgeColor: MotionValue<string>;
};

export default function StepBadge({ idx, setRef, badgeBg, badgeColor }: Props) {
  const theme = useTheme();

  return (
    <Box
      ref={setRef}
      component={motion.div}
      aria-hidden
      whileHover={{
        scale: 1.15,
        rotate: [0, -5, 5, 0],
        boxShadow: theme.shadows[3],
        transition: { duration: 0.3 },
      }}
      whileTap={{ scale: 0.95 }}
      style={{
        backgroundColor: badgeBg,
        color: badgeColor,
        cursor: "pointer",
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: { xs: 48, md: 80 },
        height: { xs: 48, md: 80 },
        borderRadius: 2,
        fontWeight: 800,
        fontSize: { xs: "1rem", md: "1.75rem" },
        boxShadow: 0,
        flexShrink: 0,
        zIndex: 1,
      }}
    >
      {String(idx + 1).padStart(2, "0")}
    </Box>
  );
}
